import { Link } from 'react-router-dom';

const HIGHLIGHTS = [
  {
    icon: '📦',
    title: 'Full load pipeline',
    body: 'Create, dispatch, and track loads from one control room.',
  },
  {
    icon: '💰',
    title: 'Settlements & AR',
    body: 'Auto-calculate driver pay, generate invoices, chase collections.',
  },
  {
    icon: '🔒',
    title: 'Verified team access',
    body: 'Work-email verification keeps every user accountable.',
  },
];

/**
 * Clean two-column auth layout.
 * Left: dark-blue brand panel. Right: solid-white form — no blur, no overlay distortion.
 */
export function AuthShell({ eyebrow, headline, subhead, children }) {
  return (
    <div className="auth-shell">
      {/* ── Left brand panel ── */}
      <aside className="auth-shell__left">
        <div className="auth-shell__grid" aria-hidden />

        {/* Brand */}
        <div className="relative z-10">
          <Link to="/login" className="inline-block focus-visible:outline-none">
            <span className="brand-text text-4xl font-bold text-white tracking-tight">
              Logistic<span className="text-sky-400">Slash</span>
            </span>
          </Link>
          <p className="mt-2 text-[10px] uppercase tracking-[0.22em] text-white/50 font-medium">
            Transportation management system
          </p>
        </div>

        {/* Copy */}
        <div className="relative z-10 space-y-8 max-w-xs">
          {eyebrow ? (
            <p className="text-[10px] uppercase tracking-[0.18em] text-sky-300/80 font-semibold">
              {eyebrow}
            </p>
          ) : null}
          <h2 className="brand-text text-[1.85rem] leading-[1.18] font-bold text-white">
            {headline}
          </h2>
          {subhead ? (
            <p className="text-sm text-white/65 leading-relaxed">{subhead}</p>
          ) : null}

          <ul className="space-y-5">
            {HIGHLIGHTS.map((item, i) => (
              <li
                key={item.title}
                className="auth-shell__feature flex gap-3 items-start"
                style={{ animationDelay: `${100 + i * 80}ms` }}
              >
                <span className="text-base mt-0.5 shrink-0">{item.icon}</span>
                <div>
                  <p className="text-sm font-semibold text-white">{item.title}</p>
                  <p className="text-xs text-white/55 mt-0.5 leading-snug">{item.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        <p className="relative z-10 text-xs text-white/35">
          Logistic Slash · Wyoming · support@logisticslash.com
        </p>
      </aside>

      {/* ── Right form panel ── */}
      <main className="auth-shell__right">
        <div className="w-full max-w-[400px]">
          {/* Mobile-only logo */}
          <div className="lg:hidden mb-8 text-center">
            <span className="brand-text text-3xl font-bold text-foreground">
              Logistic<span className="text-primary">Slash</span>
            </span>
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-2">
              Transportation management
            </p>
          </div>

          <div className="auth-card">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
